// extracted by mini-css-extract-plugin
module.exports = {"logo":"Origin_logo__6GY63","base":"Origin_base__ndnk5","rain":"Origin_rain__2jumy"};